<template>
    <div class="page-container">
        <Header></Header>
        <div class="blog-container" style="max-width: 800px">
            <div style="height: 50px"></div>
        <v-card
                max-width="800px"
                class="mx-auto"
        >
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="headline" style="white-space: pre-wrap;
                    margin-bottom: 10px">{{blog.title}}</v-list-item-title>
                    <v-list-item-subtitle class="headline-info" style="white-space: pre-wrap;
                    margin-bottom: 5px;">
                        by {{authorName}}, {{blog.date}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-img
                    :src='blog.imgSrc'
                    :lazy-src='blog.imgSrcLowRes'
                    max-height="500px"
            ></v-img>

            <v-card-text class="text" style="text-align: left; color: black; white-space: pre-wrap;
            padding: 15px;" v-html="blog.teaserText"></v-card-text>
            <div v-if="blog.contentDTOS">
                <div style="margin-bottom: 15px" v-for="content in blog.contentDTOS" :key="content.id">
                    <v-list-item-title style="margin-top: 15px; margin-left: 15px; margin-bottom: 10px; font-size: 25px;
                    font-weight: bold; text-align: left; white-space: pre-wrap" class="headline-two">{{content.title}}</v-list-item-title>
                    <div v-if="content.imgSrc !== null">
                        <v-img
                                :src=content.imgSrc
                                max-height="500px"
                        ></v-img>
                    </div>
                    <v-card-text class="text" style="text-align: left; white-space: pre-wrap;
                    padding: 15px;" v-html="content.text"></v-card-text>
                </div>
            </div>
            <v-card-actions style="align-items: center;">
                <v-btn large color="black" style="margin-left: auto; margin-right: auto; color: white" type="text" :to="{name: 'AllBlogsPage'}"
                >
                    Back
                </v-btn>
            </v-card-actions>
            <div style="height: 30px;"></div>
        </v-card>
            <v-card style="width: 100%; background: white;">
                <div class="row" style="width: 100%; background: black">

                     <div class="spacer-left"></div>
                    <div class="content-div">
                        <p>about the author</p>
                    </div>

                    <div class="author-image-container" style="max-width: 30%;">
                        <img class="author-image" :src="authorImg" style="max-width: 100%; max-height: 300px">
                    </div>

                    <div class="author-wrapper">
                        <div class="author-name">
                            <p>{{authorName}}</p>
                        </div>
                        <div class="author-description">
                            <p style="padding-top: 10px; white-space: pre-wrap;">{{authorDescription}}</p>
                        </div>
                    </div>

                </div>
            </v-card>
        </div>
        <div style="height: 50px;"></div>
        <Footer></Footer>
    </div>
</template>

<script>

    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import {mapActions} from "vuex";
    import axios from 'axios';

    export default {
        name: "BlogDetailPage",
        components: {Footer, Header},
        props: {
            id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                blog: {},
                authorImg: null,
                authorName: null,
                authorDescription: null
            }
        },
        computed: {
            ...mapActions(['getBlogById', 'fetchBlogList', 'fetchAuthor']),
        },
        mounted () {
            window.scrollTo(0, 0);
        },
        created() {
            console.log(this.id);
            this.$store.dispatch('getBlogById', this.id.toString()).then((response) => {
                console.log(response);
                this.blog = response;
            });

            const url = 'https://heroku-adminservice.herokuapp.com/blogs/author';
            axios.get(url, {params: {blogId: this.id}}).then(response => {
                this.authorImg = response.data.authorImage;
                this.authorName = response.data.displayName;
                this.authorDescription = response.data.authorDescription;
                console.log(this.authorImg);
            })
        },
    }
</script>

<style scoped>

    .headline {
        font-size: 35px; font-weight: bold;
    }

    .headline-info {
        font-size: 15px;
    }

    .row {
        margin: 0;
    }

    .author-image {
        border-radius: 20%;
    }

    .author-wrapper {
        color: white;
        width: 70%;
        padding-left: 15px; padding-right: 15px; padding-bottom: 15px;
    }

    .author-name {
        width: 100%;
        text-align: left;
        font-size: 35px;
        color: #FFD700;
        font-family: 'Mansalva', cursive;
        padding-left: 10px;
    }

    .author-description {
        width: 100%;
        text-align: left;
        font-size: 19px;
        padding-left: 10px;
    }

    .spacer-left {
        min-width: 30%;
        max-width: 30%;
        min-height: 70px;
    }

    .content-div {
        min-width: 70%;
        max-width: 70%;
        text-align: left;
        min-height: 70px;
        color: white;
        padding: 15px;
    }

    .content-div p {
        padding-left: 10px;
        font-family: 'Mansalva', cursive;
        font-size: 60px;
    }

    .text {
        font-size: 19px;
        line-height: 2rem;
    }

    @media screen and (max-width: 700px) {
        .text {
            font-size: 15px;
            line-height: 1.5rem;
        }

        .author-description {
            font-size: 15px;
        }
    }

    @media only screen and (max-width: 520px) {
        .author-wrapper {
            width: 100%!important;
            padding: 15px;
        }
        .author-image-container {
            max-width: 100%!important;
        }

        .spacer-left {
            min-width: 0;
            max-width: 0;
        }

        .content-div {
            min-width: 100%;
            max-width: 100%;
            padding: 0;
            text-align: center;
        }

        .content-div p {
            padding-left: 0;
            font-size: 40px;
        }

        .author-image {
            max-height: max-content!important;
            width: 100vw!important;
        }

        .author-name {
            text-align: center;
            font-size: 30px;
            color: #FFD700;
            font-family: 'Mansalva', cursive;
            padding-left: 0;
            padding-top: 10px;
        }
    }



    @media only screen and (max-width: 500px) {
        .headline {
            font-size: 25px;
        }
    }

    @media only screen and (min-width: 700px) and (max-width: 899px){
        .blog-container {
            max-width: 700px;
            margin: auto
        }
    }

    @media only screen and (min-width: 900px) {
        .blog-container {
            max-width: 800px;
            margin: auto
        }
    }
</style>
